// 字符串转换
export default class TextConverter {
  type = 'text';

  toQuery(item) {
    const must = [];
    const mustNot = [];
    const { formData, columnInfo } = item;
    if (columnInfo.type !== this.type) {
      return;
    }

    const isTerm = ['term', 'term_not'].includes(formData.rule);
    const isExists = ['exists', 'exists_not'].includes(formData.rule);
    let queryKey = 'match_phrase';
    let columnKey = `${columnInfo.columnKey}`;
    let defaultVal = '';
    if (isTerm) {
      if (formData.keywordMode === 'remote') {
        queryKey = 'terms';
        defaultVal = [];
        columnKey = `${columnInfo.columnKey}.fullname.keyword`;
      } else {
        queryKey = 'term';
        columnKey = `${columnInfo.columnKey}.keyword`;
      }
    } else if (isExists) {
      queryKey = 'range';
      columnKey = `${columnInfo.columnKey}.size`;
    }

    let queryItem = { [queryKey]: { [columnKey]: defaultVal } };

    // 代理must和mustNot
    const queryArr = ['exclude', 'term_not', 'exists_not'].includes(formData.rule) ? mustNot : must;

    const index = queryArr.findIndex(mustItem => {
      return Object.prototype.hasOwnProperty.bind(mustItem[queryKey])(columnKey);
    });
    if (index > -1) {
      queryItem = queryArr[index];
    } else {
      queryArr.push(queryItem);
    }
    if (isExists) {
      queryItem[queryKey][columnKey] = { gt: 0 };
    } else {
      queryItem[queryKey][columnKey] = queryKey === 'terms' ? formData.keywordArr : formData.keyword;
    }
    return { must, must_not: mustNot };
  }
}
